import { blobToBase64 } from '@utils/blobToBase64';

export const useUploadImageS3 = () => {
  const getImageFromS3 = async (image: string) => {
    const data = await fetch(image, { cache: 'no-cache' });
    const blob = await data.blob();
    const base64 = await blobToBase64(blob);
    return base64;
  };

  return { getImageFromS3 };
};
